import { crane } from '../beasts';
import { cloud } from '../motifs';
import { M, PAPER, WHITE } from '../palette';
import { registerPlate } from '../registry';

const SUN = ['#e8503a', M.red, M.redLo] as const;

/** 14 กระเรียนขาว: the white crane's plate, warm paper before a red sun, a crane flying off the left. */
registerPlate({
  id: 'crane',
  name: 'กระเรียนขาว',
  ground: PAPER,
  trim: M.maroon,
  text: { fill: [M.ink, '#000000'], line: M.whiteHi },
  inset: [20, 11],
  tassels: [{ x: 3 }, { x: -4, charm: 'coin' }],
  back(p, f) {
    p.disc(f.r - 10, f.y + 1, 14, SUN[1]);
    p.disc(f.r - 8, f.y - 1, 10, SUN[0]);
  },
  front(p, f) {
    crane(p, f.x + 9, f.y + 3, 1.3, true);
  },
  motion: {
    sprites: { wisp: { w: 12, h: 8, draw: (p) => cloud(p, 0, 8, 12, WHITE) } },
    play(a, t, f) {
      // A thin cloud drifting across the sun.
      a.spr('wisp', f.r - 22 + Math.sin(t * 0.5) * 6, f.y - 9);
    },
  },
});
